<template lang="pug">
//- 流程设置进入的展示页面
#processContainer(element-loading-text="数据读取中..." v-loading="loading")
  splitpanes.default-theme(:dbl-click-splitter="false")
    pane.column-left(min-size="14",size="15")
      el-button(icon="el-icon-plus" v-if="addBoolean" size="small" type="primary" @click="openDialogGroup('add')") 新建流程分组
      .title
        span 全部流程：
        span.color {{totalCount}}
      .list_card
        .filterInput
          el-input(v-model='filterText' placeholder="输入流程名称进行过滤",size="small")
        el-tree(:data="flowGroupList",
          ref="dataTree",
          :key="activeIndex"
          highlight-current,
          default-expand-all,
          :props="defaultProps",
          :filter-node-method="filterNode",
          :expand-on-click-node="false",
          node-key="id",
          @node-click="handleNodeClick"
          @node-drop="handleDrop"
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
          v-slot="{ node, data }")
          .group
            img(:src="require('@/CommonDP/assets/approval/group.png')" alt="图片")
            .group_name(:class="{largeSize: data.name === '全部流程'}") {{data.name}}
            .icon(v-if="data.name !== '全部流程'")
              i(class="el-icon-plus tubiao"  title="添加子集" @click.stop="openDialogGroup('add',data)")
              i(class="el-icon-edit-outline tubiao" v-if="editGroupBoolean(data)" title="编辑" @click.stop="openDialogGroup('edit',data)")
              i(class="el-icon-delete tubiao" v-if="deleteGroupBoolean(data)" title="删除" @click.stop="deleteGrouping(data)")
    pane.column-right(min-size="80",size="85")
      .contral
        .btn
          el-button( size="small" type="primary" v-if="checkNode&&checkNode.name!=='全部流程'" @click="openBoard") 新建流程模板
          el-button(type="danger" size="small" plain :disabled="!multipleSelection.length" @click="flowDel") 删 除
          el-button(type="primary" size="small" plain :disabled="!multipleSelection.length" @click="flowOpen") 启 用
          el-button(type="primary" size="small" plain :disabled="!multipleSelection.length" @click="flowStop") 禁 用
          el-button(type="primary" size="small" plain :disabled="!multipleSelection.length" @click="showMoveDialog") 移 动
        el-input(v-model="searchkeyWord" class="rightSearch" placeholder="请输入流程名称" size="small" suffix-icon="el-icon-search" clearable @change="filerFlowList")
      .flowTable
        el-table( :data="definitionTable" :key="definitionTable.length" ref="sortTable" @selection-change="handleSelectionChange" height="100%" border)
          el-table-column(type="selection" width="55" align="center")
          el-table-column(v-if="checkNode.name !== '全部流程'" width="60" align="center")
            i(class="iconfont icon-drag drag-option my-handle" style="cursor: pointer")
          el-table-column(label="流程名称" show-overflow-tooltip prop="flowName" align="center")
          el-table-column(label="创建人"  prop="createUserName" align="center")
          el-table-column(label="流程描述" show-overflow-tooltip prop="description" align="center")
          el-table-column(label="所属分组" show-overflow-tooltip prop="groupName" align="center")
          el-table-column(label="当前版本/最新版本"  prop="flowName" align="center" v-slot="{row}")
            el-popover(placement="top-start" title="" width="200" trigger="hover" content="当前版本不是最新版本")
              span(slot="reference")
                i.warn(v-if="row.currentVersion !== row.newestVersion" class="el-icon-warning")
            span.currentVersion {{row.currentVersion}}/
            span.newestVersion {{row.newestVersion}}
          el-table-column(label="流程状态"  prop="flowName" align="center" v-slot="{row}")
            span.stop(v-if="row.isEnable == 0") 已禁用
            span.open(v-else) 已启用
          el-table-column(v-if="onlinePrintDesign" label="打印模板"  prop="flowName" align="center" v-slot="{row}")
            //- TODO 有的没有不使用在线表单
            el-button(v-if="row.isDynamicForm" type="text" class="operBtn" @click.stop="openDesignPrint(row)") 在线设计
          el-table-column(label="操作"  prop="flowName" align="center" width="240px" v-slot="{row}")
            el-button(type="text" class="operBtn" @click.stop="openApprovalRecord(row)") 审批记录
            el-button(type="text" class="operBtn" @click.stop="openVersion(row)") 查看版本
            el-button(type="text" class="operBtn" @click.stop="viewFlow(row,2)") 查看
            el-button(type="text" class="operBtn" @click.stop="viewFlow(row,1)") 编辑
      .page
        el-pagination(:current-page.sync="page.pageNum"
          :page-size="page.pageSize"
          :layout="page.pageLayout"
          :total="page.totalCount"
          v-if="page.totalCount > 0"
          :page-sizes="[10, 20, 50, 100]"
          size="small"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange")
  el-dialog(:title="groupTitle" :visible.sync="groupDialog" width="20%" :before-close="handleClose")
    el-form(ref="flowGroupForm" :model="flowGroupParams" :rules="rules" label-width="80px" label-position="top" size="small")
      el-form-item(label="父级" prop="pName" v-if="flowGroupParams.pName")
        el-input(v-model="flowGroupParams.pName" disabled)
      el-form-item(label="分组名称" prop="name")
        el-input(v-model.trim="flowGroupParams.name" placeholder="请输入" maxlength="15" show-word-limit )
    div(slot="footer")
      el-button(@click="handleClose" size="small") 取 消
      el-button(type="primary" @click="onSubmit" size="small") 确 定
  el-dialog(title="移动至分组" :visible.sync="moveDialog" width="300px" :before-close="moveClose")
    el-cascader(
        style="width: 100%;"
        v-model="moveGroupId"
        :options="flowGroupList"
        placeholder="请选择分组"
        :props="moveGroupProps"
        clearable )
    div(slot="footer")
      el-button(@click="moveClose" size="small") 取 消
      el-button(type="primary" @click="flowMove" size="small") 确 定
  processVersion(ref="processVersion" @updateSet="getFlowlist" @seeVersion="seeVersion")
  processLog(ref="processLog")
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import processVersion from "./processVersion.vue";
import processLog from "./processLog.vue";
import { setGroupName, updateInit, setFormData, setFormFieldList } from "../config";
import Sortable from "sortablejs";
import { tree2Map } from "@/CommonDP/utils/index.js";
import { windowOpen } from "@/CommonDP/utils/docPublic";
import globalParams from "@/CommonDP/utils/globalParams";
const dialogParams = () => ({
  id: "",
  pName: "",
  pid: "",
  name: ""
});
export default {
  components: { Splitpanes, Pane, processVersion, processLog },
  data() {
    return {
      searchkeyWord: "",
      loading: false,
      flowGroupList: [], // 流程类型
      totalCount: 0,
      activeIndex: 0,
      filterText: "",
      defaultProps: {
        children: "children",
        label: "name"
      },
      moveGroupProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true
      },
      moveGroupId: "",
      definitionTable: [],
      checkNode: {}, // 选中的节点
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes,prev, pager, next,jumper" // 分页组件
      },
      groupType: "add",
      groupDialog: false,
      flowGroupParams: dialogParams(),
      rules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "change" }]
      },
      multipleSelection: [], // 选中的流程
      moveDialog: false,
      // eslint-disable-next-line
      _sortable: null,
      curRow: null,
      onlinePrintDesign: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    addBoolean() {
      return checkPermission(":processDefinition:addGroup");
    },
    groupTitle() {
      return this.groupType === "add" ? "新建流程分组" : "编辑流程分组";
    }
  },
  watch: {
    filterText(val) {
      this.$refs.dataTree.filter(val);
    },
    checkNode() {
      if (this._sortable) {
        this._sortable.option("disabled", !this.checkNode?.id);
      }
    }
  },
  mounted() {
    this.onlinePrintDesign = globalParams.get("onlinePrintDesign");
    this.getFormGroupList(true);
    this.rowDrop();
    window.addEventListener("deliveryFileId", this.deliveryFileId);
  },
  beforeDestroy() {
    window.removeEventListener("deliveryFileId", this.deliveryFileId);
  },
  methods: {
    deliveryFileId(e) {
      const { detail } = e;
      this.curRow.printTemplateFileId = detail;
    },
    openDesignPrint(row) {
      this.curRow = row;
      const { flowName, flowDefinitionId, currentVersionId, flowKey, printTemplateFileId: fileId } = row;
      console.log(fileId, "fileId");
      windowOpen({
        path: "/printDesignDoc",
        query: {
          prjId: this.prjId,
          enterpriseId: this.enterpriseId,
          flowName,
          flowDefinitionId,
          currentVersionId,
          flowKey,
          fileId
        }
      });
    },
    // dropType 被拖拽节点的放置位置（before、after、inner）
    handleDrop(draggingNode, dropNode, dropType, event) {
      const _flowGroupListMap = tree2Map(this.flowGroupList);
      const index = _flowGroupListMap[draggingNode.data.pid].findIndex((item) => item === draggingNode.data);
      flowService.moveGroup(draggingNode.data.id, index);
    },
    rowDrop() {
      // 此时找到的元素是要拖拽元素的父容器
      const dom = document.querySelector(".el-table__body-wrapper tbody");
      this._sortable = Sortable.create(dom, {
        handle: "#processContainer .flowTable .my-handle",
        onEnd: async (e) => {
          // const curGroupId = this.definitionTable[e.oldIndex].appCode;
          // applicationSettingsService.updateAppOrder(curGroupId, e.newIndex + 1);
          this.loading = true;
          await flowService.moveFlow(this.definitionTable[e.oldIndex].flowDefinitionId, e.newIndex + 1);
          this.loading = false;
        }
      });
    },
    filerFlowList() {
      this.page.pageNum = 1;
      this.getFlowlist();
    },
    allowDrop(draggingNode, dropNode, type) {
      return dropNode.data.name !== "全部流程" && draggingNode.data.pid === dropNode.data.pid && type !== "inner";
    },
    allowDrag(draggingNode) {
      return draggingNode.data.name.indexOf("全部流程") === -1;
    },
    // 新建流程模板
    openBoard() {
      setGroupName(this.checkNode);
      updateInit();
      this.$emit("openDesigner");
    },
    updateNodes() {
      this.getFlowlist();
    },
    // 是否可编辑流程
    editGroupBoolean(data) {
      return data.isDefault !== null && checkPermission(":processDefinition:editGroup");
    },
    // 是否可删除
    deleteGroupBoolean(data) {
      return data.isDefault !== null && checkPermission(":processDefinition:deleGroup");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(data, node) {
      this.checkNode = data;
      this.getFlowlist();
      this.rowDrop();
    },
    // 获取左侧所有节点的接口
    async getFormGroupList(boolean) {
      const res = await flowService.queryGroupList(this.enterpriseId);
      this.flowGroupList = res.data || [];
      this.flowGroupList.unshift({
        id: "",
        name: "全部流程",
        definitionCount: 0,
        enterpriseId: null,
        isDefault: 1,
        children: [],
        pid: "0",
        orderNum: 1
      });
      if (this.flowGroupList.length > 0) {
        if (boolean) this.expandFirstNodes(this.flowGroupList[0]);
        else this.expandFirstNodes(this.checkNode);
      }
      this.activeIndex++;
      this.totalCount = 0;
      const list = [...this.flowGroupList];
      for (const row of list) {
        this.totalCount += row.definitionCount || 0;
        if (row.children && row.children.length > 0) {
          for (const iterator of row.children) {
            list.push(iterator);
          }
        }
      }
    },
    // 获取当前节点的所有流程（右侧表格数据）
    async getFlowlist() {
      const {
        page: { pageNum, pageSize },
        enterpriseId,
        searchkeyWord
      } = this;
      const params = {
        groupId: this.checkNode.id,
        flowName: searchkeyWord,
        pageNum,
        pageSize,
        enterpriseId
      };
      this.loading = true;
      const res = await flowService.getFlowlist(params);
      this.definitionTable = res.data;
      this.page.totalCount = res.totalCount;
      this.page.pageNum = res.pageIndex;
      this.loading = false;
      this.$nextTick(() => {
        this.rowDrop();
      });
    },
    // 默认选中的一个流程
    async expandFirstNodes(data) {
      this.checkNode = data;
      await this.$nextTick();
      this.$refs.dataTree.setCurrentKey(data.id);
      this.getFlowlist();
    },
    // 打开新增/编辑节点的弹框
    async openDialogGroup(type, data) {
      this.groupType = type;
      let pid;
      let pName = "";
      let name = "";
      let id = "";
      if (type === "add" && !data) {
        pid = 0;
      } else if (type === "add" && data) {
        pid = data.id;
        pName = data.name;
      } else if (type === "edit") {
        id = data.id;
        pid = data.pid;
        name = data.name;
      }
      this.flowGroupParams = { pid, pName, name, id };
      this.groupDialog = true;
      await this.$nextTick();
      this.$refs.flowGroupForm.clearValidate();
    },
    // 弹框新增/编辑左侧节点树接口确认按钮
    onSubmit() {
      this.$refs.flowGroupForm.validate((valid) => {
        if (valid) {
          if (this.groupType === "add") {
            this.addFlowGroup();
          } else if (this.groupType === "edit") {
            this.editFlowGroup();
          }
        }
      });
    },
    // 添加左侧节点
    async addFlowGroup() {
      const {
        flowGroupParams: { pid, pName, name },
        enterpriseId
      } = this;
      const params = { pid, pName, name, enterpriseId };
      try {
        await flowService.addFlowGroup(params);
        this.$message.success("添加成功");
        this.flowGroupParams = dialogParams();
        this.getFormGroupList();
        this.groupDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑左侧节点树
    async editFlowGroup() {
      const {
        flowGroupParams: { pid, id, name },
        enterpriseId
      } = this;
      const params = { pid, id, name, enterpriseId };
      try {
        await flowService.updateFlowGroup(params);
        this.$message.success("修改成功");
        this.flowGroupParams = dialogParams();
        this.getFormGroupList();
        this.groupDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    // 删除选中的节点
    deleteGrouping(data) {
      const { name, id } = data;
      this.$confirm(`您确定要删除分组 ${name} 吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      })
        .then(async () => {
          await flowService.delFlowGroup(id);
          this.$success("已删除");
          this.getFormGroupList();
        })
        .catch(() => {
          // this.$message.info("已取消删除");
        });
    },
    handleClose() {
      this.flowGroupParams = dialogParams();
      this.groupDialog = false;
    },
    moveClose() {
      this.moveDialog = false;
    },

    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getFlowlist();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getFlowlist();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 删除
    flowDel() {
      this.flowOperator(`您确定要删除选中流程吗?`, "deleteFlow", "流程删除成功");
    },
    // 禁用
    flowStop() {
      this.flowOperator(`您确定要禁用选中流程吗?`, "disableFlow", "流程禁用成功");
    },
    // 启用
    flowOpen() {
      this.flowOperator(`您确定要启用选中流程吗?`, "enableFlow", "流程启用成功");
    },
    flowOperator(confirmContent, requestName, successTip) {
      this.$confirm(confirmContent, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const idList = this.multipleSelection.map((e) => e.flowDefinitionId);
          await flowService[requestName](idList);
          this.getFormGroupList();
          this.getFlowlist();
          this.$success(successTip);
        })
        .catch(() => {
          // this.$message.info("已取消删除");
        });
    },
    // 移动
    showMoveDialog() {
      this.moveDialog = true;
    },
    // 移动
    async flowMove() {
      const ids = this.multipleSelection.map((e) => e.flowDefinitionId);
      const params = {
        ids,
        groupId: this.moveGroupId[this.moveGroupId.length - 1]
      };
      try {
        await flowService.move(params);
        this.getFormGroupList();
        this.getFlowlist();
        this.$success("流程移动成功");
        this.moveDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    // 打开审批记录
    openApprovalRecord(row) {
      this.$refs.processLog.openDialog(row);
    },
    // 查看版本
    openVersion(row) {
      this.$refs.processVersion.openVersion(row);
    },
    seeVersion(row, flowKey) {
      const newRow = { ...row, flowKey: flowKey, currentVersionId: row.flowDefinitionVersionId };
      this.viewFlow(newRow, 2);
    },
    // 查看/编辑流程页面
    async viewFlow(row, mode) {
      try {
        setGroupName(this.checkNode);
        const queryForEdit = mode === 1 ? 1 : 0;
        const res = await flowService.queryFlowDef(row.currentVersionId, row.flowDefinitionId, row.flowKey, queryForEdit);
        setFormData(res.data);
        const { formApprovePcCode, formCode } = res.data;
        const formId = formApprovePcCode || formCode;
        if (formId) this.queryFormColumns(formId);
        this.$emit("openDesigner", mode);
      } catch (error) {
        console.log(error);
      }
    },
    async queryFormColumns(formId) {
      const res = await flowService.queryFormColumns(formId);
      const array =
        res.data
          .filter((e) => e.isInternalField !== 1)
          .map((e) => {
            return {
              ...e,
              name: e.label,
              formField: e.name,
              isCanView: 1,
              isCanUpdate: 0,
              isRequired: e.required ? 1 : 0,
              isEnabled: e.required ? 1 : 0
            };
          }) || [];
      setFormFieldList("web", array);
    }
  }
};
</script>

<style lang="scss" scoped>
#processContainer {
  width: 100%;
  height: 100%;
}
.splitpanes.default-theme .splitpanes__pane {
  background-color: #fff;
}
.column-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--small-space) 0;
  .title {
    padding: var(--middle-space) var(--big-space);
    margin-top: var(--small-space);
    width: 100%;
    border-top: 1px solid #ebefff;
    border-bottom: 1px solid #ebefff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 16px;
  }
  .largeSize {
    font-size: 12px;
    font-weight: 400;
  }
  .color {
    color: #346ffa;
    font-weight: 700;
  }
  .list_card {
    width: 100%;
    height: calc(100% - 80px);
    overflow-y: auto;
  }
  .filterInput {
    padding: var(--middle-space) var(--big-space) var(--small-space);
  }
  .group {
    width: 100%;
    // height: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding-right: 10px;
    .group_name {
      margin-left: 7px;
      overflow-x: auto;
    }
    .icon {
      margin-left: auto;
      font-size: 16px;
      i {
        margin-left: 5px;
      }
    }
  }
}
.column-right {
  height: 100%;
  overflow-y: auto;
  padding: 0 var(--big-space);
}
.warn {
  color: #ff0000;
}
.contral {
  width: 100%;
  padding: var(--middle-space) 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .rightSearch {
    margin-left: auto;
    width: 300px;
  }
}
.stop {
  color: #ec3226;
}
.open {
  color: #00b632;
}
.currentVersion {
  color: #00b632;
}
.newestVersion {
  color: #f37c26;
}
.flowTable {
  height: 1px;
  flex-grow: 1;
}
.page {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
</style>
